import Util from '../../../../utils/util';
import Global from '../../../../utils/global';

import { ref } from '@vue/composition-api';

export default function downloadSetup() {
  // data
  const browserDownloadUrl = ref('');
  const browserVersion = ref(64);
  const browserOptions = ref([
    { value: 32, label: '科达浏览器 chromium 32位版本' },
    { value: 64, label: '科达浏览器 chromium 64位版本' }
  ]);

  // 获取当前浏览器版本
  let agent = navigator.userAgent.toLowerCase();
  if (agent.indexOf('win64') >= 0 || agent.indexOf('wow64') >= 0) {
    browserVersion.value = 64;
  } else {
    browserVersion.value = 32;
  }
  if (Global.getCustomConfig()['KIAF_BROWSER_DOWNLOAD_URL']) {
    browserDownloadUrl.value = Global.getCustomConfig()['KIAF_BROWSER_DOWNLOAD_URL'];
    if (browserDownloadUrl.value && Array.isArray(browserDownloadUrl.value)) {
      browserOptions.value = Util.clone(browserDownloadUrl.value);
    }
  }

  // 下载浏览器
  const downloadBrowser = () => {
    let url = '';
    if (browserDownloadUrl.value && Array.isArray(browserDownloadUrl.value)) {
      browserDownloadUrl.value.forEach((item) => {
        if (item.value === browserVersion.value) {
          url = item.url;
        }
      });
    } else {
      url = browserDownloadUrl.value[browserVersion.value];
    }
    if (url) {
      var link = document.createElement('a');
      link.target = '_blank';
      link.href = url; //'http://kfront.kedacom.com/file/resourceFile/chromium-keda-70.0.3538.67.20190402_x86/chromium-keda-70.0.3538.67.20190402_x86.rar';
      link.click();
    } else {
      Util.errorMessage('没有找到合适的版本');
    }
  };

  return {
    browserDownloadUrl,
    browserVersion,
    browserOptions,
    downloadBrowser
  };
}
